module.exports = __webpack_public_path__ + "img/infotopimg.8950f002.png";